<script setup>
import DateTimePicker from '@/components/DateTimePicker.vue'
import { DateTime } from 'luxon'

const props = defineProps({
  modelValue: { type: DateTime, default: null },
  enableTimeJumper: { type: Boolean, default: false },
})
defineEmits(['update:modelValue', 'update:enableTimeJumper'])
</script>

<template>
  <div>
    <DateTimePicker
      :model-value="props.modelValue"
      :hide-details="true"
      variant="solo"
      :default-props="{ VTextField: { rounded: undefined } }"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <template #append-inner>
        <v-tooltip
          location="bottom"
          close-on-content-click
          scroll-strategy="close"
        >
          <template #activator="{ props: tooltipProps }">
            <v-icon
              v-bind="tooltipProps"
              class="pa-4 cursor-pointer"
              :icon="props.enableTimeJumper ? 'mdi-clock-end' : 'mdi-clock-start'"
              :color="props.enableTimeJumper ? 'primary' : 'default'"
              @click="$emit('update:enableTimeJumper')"
            />
          </template>
          {{ $t('canvas.time_jumper') }}
        </v-tooltip>
      </template>
    </DateTimePicker>
  </div>
</template>

<style scoped></style>
